import { Component, Input } from '@angular/core';
import { WaitingIndicatorService } from '../../core-services/WaitingIndicator.service';
import { TranslationService } from '../../translations';

@Component({
    selector: 'screen-block',
    template: `
        <div
            [hidden]="!coordinator.blockScreen"
            class="modal-backdrop fade in"
        ></div>
        <div [ngClass]="{ 'pi-dashboard--loading': coordinator.blockScreen }">
            @if (!hideSpinner) {
                <div class="pi-dashboard_loading-indicator">
                    <div class="spinner spinner--person"></div>
                </div>
            }
        </div>
    `,
    standalone: false
})
export class ScreenBlockComponent {
    @Input() hideSpinner = false;
    constructor(
        public coordinator: WaitingIndicatorService,
        public TR: TranslationService
    ) {}
}
